export enum MainTagTypeEnum {
    INFO = "info",
    SUCCESS = "success",
    WARNING = "warning",
    ERROR = "error",
}

export interface IMainTag {
    children: React.ReactNode | String;
    className?: string;
    small?: boolean;
    fontBold?: boolean;
    type?: MainTagTypeEnum;
}
